
export default class DobleFactorAuth {
    static EMAIL = 'doblefactorauth-email'
    static SMS = 'doblefactorauth-sms'
    static APP = 'doblefactorauth-app'
  }
  